module.exports = __webpack_public_path__ + "img/plantao-medico-24h.b5ba40c0.png";